module.exports = __webpack_public_path__ + "static/media/Figure_S5.cf65da13.png";